// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-vKjLf"};